function mapAccountabilityActionUrl(accountabilityType, accountabilityId) {
  return accountabilityType === 'OneColumn' ? '/verantwoording/' + accountabilityId : '/machtiging/' + accountabilityId;
}

const undefinedTypeInfo = function (toDo) {
  return {
    icon: 'icons/check_approval.svg',
    title: 'Geen mapping beschikbaar',
    description: 'Geen mapping beschikbaar',
    actionActivatesAccountabilityId: false,
    actionActivatesOsaEvaluationId: false,
    actionUrl: null
  };
};

const typeInfos = {
  IncompleteAccountability: function (toDo) {
    return {
      icon: 'icons/timelapse.svg',
      title: 'Verantwoording afronden',
      description: toDo.accountabilityTemplateName,
      actionActivatesAccountabilityId: true,
      actionActivatesOsaEvaluationId: false,
      actionUrl: mapAccountabilityActionUrl(toDo.accountabilityType, toDo.accountabilityId)
    };
  },
  ForwardedIncompleteAccountability: function (toDo) {
    return {
      icon: 'icons/timelapse_forward.svg',
      title: 'Doorgestuurde Verantwoording afronden',
      description: toDo.accountabilityTemplateName,
      comment: toDo.comment,
      actionActivatesAccountabilityId: true,
      actionActivatesOsaEvaluationId: false,
      actionUrl: mapAccountabilityActionUrl(toDo.accountabilityType, toDo.accountabilityId)
    };
  },
  LicenseAboutToExpire: function (toDo) {
    return {
      icon: 'icons/license_expire.svg',
      title: 'Machtiging loopt af',
      description: toDo.accountabilityTemplateName,
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  LicenseNotLinkedToEquipment: function (toDo) {
    return {
      icon: 'icons/link-variant-off.svg',
      title: 'Pomp toewijzen',
      description: 'Er is geen pomp gekoppeld aan een machtiging',
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  LicenseWithoutApproval: function (toDo) {
    return {
      icon: 'icons/draw.svg',
      title: 'Documentatie toevoegen',
      description: 'U dient binnen 7 dagen een recept en/of uitvoeringsverzoek aan deze verantwoording toe te voegen',
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  OsaEvaluationPendingApproval: function (toDo) {
    return {
      icon: 'icons/check_approval.svg',
      title: 'Akkoordverklaring afronden',
      description: toDo.isPosa
        ? 'POSA: Akkoordverklaring levering definitieve POSA SPT apparatuur'
        : 'OSA: Akkoordverklaring levering definitieve CPAP apparatuur',
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false, // todo when navigation works correctly
      actionUrl: toDo.osaEvaluationId
        ? '/osa/akkoordverklaring/Evaluation/' + toDo.osaEvaluationId
        : '/osa/akkoordverklaring/Evaluation/0/' + toDo.licenseId
    };
  },
  OsaStopTherapy: function (toDo) {
    return {
      icon: 'icons/license_expire.svg',
      title: 'Machtiging stopzetten',
      description: toDo.isPosa
        ? 'POSA therapy: Eindoordeel definitieve evaluatie POSAS therapie = stoppen. Beëindig de machtiging voor deze therapie.'
        : 'OSA therapy: Eindoordeel definitieve evaluatie OSAS therapie = stoppen. Beëindig de machtiging voor deze therapie.',
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  ServiceCall: function (toDo) {
    return {
      icon: 'icons/license_expire.svg',
      title: 'Servicecall actie gewenst',
      description: toDo.description,
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  TransferredCustomer: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Patiëntoverdracht',
      description: toDo.description,
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  WithdrawTransferredCustomer: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Overdracht van patiënt is ingetrokken',
      description: toDo.description,
      actionActivatesAccountabilityId: false,
      actionActivatesOsaEvaluationId: false,
      actionUrl: '/patientdashboard'
    };
  },
  EquipmentReadyForMaintenance: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Onderhoud pomp inplannen',
      description: toDo.description,
      actionUrl: '/pomponderhoud'
    };
  },
  WarehouseInventoryUpdate: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Voer de voorraadtelling uit',
      description: 'De voorraadtelling staat klaar om ingevuld te worden',
      actionUrl: '/voorraadbeheer/' + toDo.id
    };
  },
  EquipmentInDepot: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Machtiging stopzetten',
      description: toDo.description,
      actionUrl: '/patientdashboard'
    };
  },
  EquipmentNotInDepot: function (toDo) {
    return {
      icon: 'icons/account-convert.svg',
      title: 'Actie voor pomp met serienummer: ' + toDo.equipmentSerialNumber + ' vereist',
      description: toDo.description,
      actionUrl: '/pompenoverzicht/' + toDo.equipmentId
    };
  }
};

export function getToDoTypeInfo(toDo) {
  return (typeInfos[toDo.type] || undefinedTypeInfo)(toDo);
}
